function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 145,312 c -2,69 31,100 104,102 78,1 113,-34 109,-101 -6,-58 -62,-73 -106,-79 -48,-17 -99,-25 -99,-95 0,-48 32,-79 99,-78 60,0 97,25 96,84",
    style: {
      fill: "none",
      stroke: "#7A7A7A",
      strokeWidth: 40
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 250,15 0,470",
    style: {
      stroke: "#7A7A7A",
      strokeWidth: 30
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollars);
export default __webpack_public_path__ + "static/media/dollars.927b9b34294f95b56b2a9c9b4cc0e9c2.svg";
export { ForwardRef as ReactComponent };